export enum TimePeriodEnum {
  AM = 'am',
  PM = 'pm',
}
